import { transformDateToLocalDateString } from "helpers";
import { PricingVersionRow } from "services/api/pricing/types";
import { Badge } from "ui/components/Badge";
import UserCell from "ui/components/Table/TableSearch/components/Cells/UserCell";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const PRICING_SEARCH_COLUMNS: Column[] = [
  {
    title: "Vrijedi od",
    field: "validFrom",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingVersionRow) => (
      <span className="font-semibold text-slate-700">
        {transformDateToLocalDateString(new Date(row.validFrom))}
      </span>
    ),
  },
  {
    title: "Naziv",
    field: "note",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingVersionRow) => (
      <span className="text-slate-700">{row.note ?? "—"}</span>
    ),
  },
  {
    title: "Status",
    field: "isEffective",
    sortable: false,
    type: ColumnTypes.custom,
    // Aktivna je uvijek točno jedna verzija, ona po kojoj se danas obračunava. Sve ostalo,
    // i nacrti i one koje su svoje odradile, je neaktivno.
    render: (row: PricingVersionRow) =>
      row.isEffective ? (
        <Badge text="Aktivan" variant="success" height="small" showDot />
      ) : (
        <Badge text="Neaktivan" variant="secondary" height="small" showDot />
      ),
  },
  {
    title: "Kreirao",
    field: "userCreatedFullName",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingVersionRow) => (
      <UserCell fullName={row.userCreatedFullName} userId={row.userCreatedId} />
    ),
  },
  {
    title: "Kreirano",
    field: "created",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingVersionRow) => (
      <span className="text-slate-500">
        {transformDateToLocalDateString(new Date(row.created))}
      </span>
    ),
  },
];
